import React, { useState, useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import {maskPhone} from '../../utils/index';
import {Formik} from 'formik';
import {
    getToken,
    getTokenReset,
    loginStep1ConfirmationCode
} from "../../actions/security";
import {
    setLoadingSpinnerOpen,
} from '../../actions/loadingSpinner';
import loadable from "../../components/Lazy";

const Recaptcha = loadable(() => import('../../components/App/Recaptcha'));

const getInitialPhoneValue = () => {
    const queryParams = new URLSearchParams(window.location.search)
    return queryParams.get("mobile");
};

const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: '660px',
        margin: '50px auto'
    },
    form: {
        maxWidth: '480px',
        margin: '10px auto 50px'
    }
}));

const LoginAccountExists = ({
    getToken,
    token,
    getTokenReset,
    getTokenSuccess,
    loginStep1ConfirmationCode,
    setLoadingSpinnerOpen
}) => {
    const classes = useStyles();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [loginToken, setLoginToken] = useState('');

    const handleSubmit = (values) => {
        loginStep1ConfirmationCode({
            username: values.phone.replace(/[^0-9]/g, ''),
            token: loginToken,
            recaptchaToken: values.recaptchaToken,
            redirect: `${window.location.origin}/secure/account/profile`
        })
    };


    useEffect(() => {
        getToken({name: 'gift_ya_send_code'})
    }, [getToken]);

    useEffect(() => {
        if (getTokenSuccess) {
            setLoginToken(token);
            getTokenReset();
        }
        // eslint-disable-next-line
    }, [getTokenSuccess, getTokenReset])

    return (
        <Container>
            <div className={classes.root}>
                <Formik
                    enableReinitialize={true}
                    validateOnMount={true}
                    initialValues={{
                        phone: maskPhone(getInitialPhoneValue()),
                        recaptchaToken: ''
                    }}
                    validate={(values) => {
                        const errors = {
                            ...(!/^[0-9]{10}$/gim.test(values.phone.replace(/[^0-9]/g, '')) && {username: 'Please enter a valid phone number'}),
                        };
                        if (Object.keys(errors).length > 0) {
                            setIsSubmitting(false);
                        }
                        return errors;
                    }}
                    onSubmit={handleSubmit}>
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        setFieldValue,
                        submitForm,
                        isValid,
                        dirty
                    }) => {

                        const handleRecaptchaSubmit = (recaptchaToken) => {
                            setFieldValue('recaptchaToken', recaptchaToken)
                            setIsSubmitting(true)
                            submitForm();
                        };
                        return (
                            // <form onSubmit={handleSubmit}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Typography variant="h2" component="h1" align="center" gutterBottom={true}>Account already exists</Typography>
                                    <Typography gutterBottom={true} align="center">GiftYa account with telephone number {maskPhone(getInitialPhoneValue())} already exists</Typography>
                                    <Typography align="center">Please login to your GiftYa account and link your social login accounts from your profile section.</Typography>
                                </Grid>
                                <Grid item xs={12} className={classes.form}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <TextField
                                                onChange={(e) => {
                                                    const value = e.target.value || "";
                                                    setFieldValue('phone', maskPhone(value));
                                                }}
                                                fullWidth={true}
                                                label="Phone number"
                                                variant="filled"
                                                color="primary"
                                                name="phone"
                                                value={values.phone}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Recaptcha
                                                onSubmit={handleRecaptchaSubmit}
                                            >
                                                {({submitAction}) => {
                                                    const handleClick = (e) => {
                                                        setLoadingSpinnerOpen(true);
                                                        submitAction(e);
                                                    }
                                                    return (
                                                        <Button
                                                            loading={isSubmitting}
                                                            onClick={handleClick}
                                                            disabled={!isValid || !token || isSubmitting}
                                                            fullWidth
                                                            variant="contained"
                                                            color="primary"
                                                        >
                                                            Get confirmation code
                                                        </Button>
                                                    )
                                                }}
                                            </Recaptcha>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            // </form>
                        )}}
                </Formik>
            </div>
        </Container>
    )
}

export default connect(
    (state) => ({
        getTokenSuccess: state.security.getTokenSuccess,
        getTokenError: state.security.getTokenError,
        token: state.security.token,
    }),
    {
        getToken,
        getTokenReset,
        loginStep1ConfirmationCode,
        setLoadingSpinnerOpen
    }
)(LoginAccountExists);